<template>
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.01608 6.21861C8.01608 7.33066 7.10898 8.23776 5.99693 8.23776C4.88489 8.23776 3.97778 7.33066 3.97778 6.21861C3.97778 5.10657 4.88489 4.19946 5.99693 4.19946C7.10898 4.19946 8.01608 5.10657 8.01608 6.21861ZM6.66886 6.21861C6.66886 5.84569 6.3665 5.54668 5.99693 5.54668C5.62737 5.54668 5.325 5.84905 5.325 6.21861C5.325 6.58817 5.62737 6.89054 5.99693 6.89054C6.3665 6.8939 6.66886 6.59153 6.66886 6.21861Z"
      fill="currentColor"
    />
    <path
      d="M12.0342 3.58814L18.1354 9.78333C18.5251 10.163 18.7502 10.7072 18.7502 11.2817C18.7502 11.8529 18.5284 12.3938 18.1421 12.7667L12.6087 18.1556C11.8427 18.8981 10.3846 18.9014 9.61529 18.1522L2.73808 11.4262C1.55212 10.2738 1.24976 9.81357 1.24976 8.25133V5.29148C1.24976 2.49961 1.81754 1.25318 5.18055 1.25318H7.95562C9.66232 1.24982 10.6568 2.23084 12.0342 3.58814ZM11.6714 17.188L17.2047 11.8025C17.3324 11.6782 17.403 11.49 17.403 11.2817C17.403 11.0701 17.329 10.8752 17.1846 10.7375L11.6479 5.09662L11.0868 4.549C9.71607 3.19506 9.06094 2.59704 7.95226 2.59704H5.17719C2.76832 2.59704 2.59362 2.96996 2.59362 5.28812V8.24797C2.59362 9.31298 2.62385 9.44065 3.67542 10.4586L10.5526 17.188C10.687 17.319 10.8886 17.3929 11.1103 17.3929C11.3321 17.3929 11.537 17.319 11.6714 17.188Z"
      fill="currentColor"
    />
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'Sale',
} as DefineComponent
</script>
